// styles/global.ts
import { createGlobalStyle } from "styled-components";
import { colors } from "./colors";

const GlobalStyle = createGlobalStyle`
  html, body, #root { height: 100%; }   /* safe everywhere */
  html { scroll-behavior: smooth; }

  body {
    font-family: "Patrick Hand", serif;
    font-weight: 400;
    font-style: normal;
    font-size: larger;
    background-color: ${colors.background};
    color: ${colors.text};
    margin: 0;
    padding: 0;
    /* NO overflow hidden here */
  }

  h2 { color: ${colors.primary}; }
`;
export default GlobalStyle;
